export class DtoXCODescuentoMst02 {
    tipoCliente: string;
    fechaDesde: string;
    fechaHasta: string;
    item: string;
    descuentoporcentaje: number;
    rango01Desde: number;
    rango01Hasta: number;
    rango01Porcentaje: number;
    rango02Desde: number;
    rango02Hasta: number;
    rango02Porcentaje: number;
    rango03Desde: number;
    rango03Hasta: number;
    rango03Porcentaje: number;
    rango04Desde: number;
    rango04Hasta: number;
    rango04Porcentaje: number;
    ultimoUsuario: string;
    ultimaFechaModif: Date;
    ventaEquipo: string;
    linea: string;
    familia: string;
    subFamilia: string;
    subFamiliaInferior: string;
    tipoCriterio: string;
    moneda: string;
    sucursal: string;
    item_all: string;
    subFamilia_all: string;
    familia_all: string;
    linea_all: string;
    ventaEquipo_all: string;
    sucursal_all: string;
    subFamiliaInferior_all: string;
    cadena: string;
    estado: string;
    empleado: number;
    descuentoAutorizado: number;
    indItem: string;

}
